import { useQuery } from "@tanstack/react-query";

import { DeliveryCost } from "types/models";
import { API } from "utils/api";

export const DELIVERY_COST_KEY = ["delivery_costs"];

export const useDeliveryCost = () => {
  const queryFn = (): Promise<DeliveryCost> =>
    API.get("delivery_costs").then(
      ({ data }: { data: DeliveryCost[] }) => data[0]
    );

  return useQuery({
    queryKey: DELIVERY_COST_KEY,
    queryFn,
    staleTime: Infinity,
    retry: false,
    retryOnMount: false,
  });
};
